<div fxLayout="column" class="layout-padd" fxLayoutGap="20px">

    <!-- title -->

    <div fxLayout="row" fxLayoutAlign="center center">
        <div fxFlex="10%" fxLayoutAlign="start center">
            <mat-icon class=" warn-ico">warning</mat-icon>
        </div>
        <div fxLayoutAlign="center center"> <span>{{"deleteClientAccountComponents.title"|translate}} </span></div>

    </div>




    <!-- content -->
    <div fxFlex fxLayoutAlign="center center" class="layout-padd text-center">
     
            <span class="mat-subheading-1" [innerHTML]="'deleteClientAccountComponents.content' | translate"></span>
 
    </div>






    <!-- button -->
    <div fxLayout="row" fxLayoutAlign="center center" class="layout-padd " fxLayoutGap="10px">

        <button fxFlex mat-stroked-button color="warn" (click)="closeDial('delete')" angulartics2On="click"
            angularticsAction="deleteAccount">{{"button.yes"|translate}}</button>

        <button cdkFocusInitial fxFlex mat-stroked-button color="primary" (click)="closeDial()"
            angulartics2On="click">{{ "button.no"|translate}}</button>

    </div>

</div>